import React from "react";
import { Grid } from "@material-ui/core";
import { Typography } from "@mui/material";
import "./Home.css";
import profile from "../../image/Morshed(profile1).png";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div>
      <section className="home" id="home">
        <div className="home-content">
          <Grid container>
            <Grid item sx={12} md={6}>
              <div className="left-side">
                <div>
                  <div className="text-one">Hello There!</div>
                  <div className="text-two">
                    <Typography variant="h4" className="span loader">
                      <span className="m">I'm</span>&nbsp;
                      <br />
                      <span className="m">M</span>
                      <span className="m">O</span>
                      <span className="m">R</span>
                      <span className="m">S</span>
                      <span className="m">H</span>
                      <span className="m">E</span>
                      <span className="m">D</span>&nbsp;
                      <span className="m">A</span>
                      <span className="m">L</span>
                      <span className="m">A</span>
                      <span className="m">M</span>
                    </Typography>
                  </div>
                  <Typography variant="h6" className="text-third">
                    Full Stack Developer
                  </Typography>
                  <div className="text-four">From Bangladesh</div>

                  <Link to="/Contacts_us">
                    <main>
                      <button className="contact_button">Hire me</button>
                    </main>
                  </Link>
                </div>
              </div>
            </Grid>
            <Grid sx={12} md={6}>
              <div className="side-image">
                <img src={profile} width="100%" alt="profile" />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </div>
  );
};

export default Home;
